import { render, staticRenderFns } from "./linkFolder.vue?vue&type=template&id=6c642988&scoped=true&"
import script from "./linkFolder.vue?vue&type=script&lang=js&"
export * from "./linkFolder.vue?vue&type=script&lang=js&"
import style0 from "./linkFolder.vue?vue&type=style&index=0&id=6c642988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c642988",
  null
  
)

export default component.exports